import { PageHeaderTitle } from './type';

export const pageHeaderTitleSettings: PageHeaderTitle = {
  componentVariants: {
    variant: {
      prop: 'variant',
      variants: {
        regular: {
          color: 'gray.dark',
        },
      },
    },
  },
};
